import { Button, cn } from "@devhop/ui";
import { AlertTriangle, X } from "lucide-react";
import { useState } from "react";
import type { StockAlertWithDetails } from "../../domain/repo/get-stock-alerts";
import { StockAlertList } from "./StockAlertList";

type StockAlertBannerProps = {
  alerts: StockAlertWithDetails[];
  onAcknowledge?: (alertId: string) => void;
  className?: string;
};

export function StockAlertBanner({
  alerts,
  onAcknowledge,
  className,
}: StockAlertBannerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (alerts.length === 0 || dismissed) {
    return null;
  }

  const outOfStockCount = alerts.filter(
    (a) => a.alertType === "out_of_stock",
  ).length;
  const hasOutOfStock = outOfStockCount > 0;

  return (
    <>
      <div
        className={cn(
          "flex items-center justify-between border-b px-4 py-2",
          hasOutOfStock
            ? "bg-destructive/10 text-destructive"
            : "bg-orange-500/10 text-orange-600 dark:text-orange-400",
          className,
        )}
      >
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsOpen(true)}
          className={cn(
            "flex items-center gap-2 hover:bg-transparent",
            hasOutOfStock
              ? "text-destructive hover:text-destructive/80"
              : "text-orange-600 hover:text-orange-600/80 dark:text-orange-400",
          )}
        >
          <AlertTriangle className="h-4 w-4" />
          <span className="font-medium text-sm">
            {alerts.length} ວັດຖຸດິບໃກ້ຫມົດ
            {hasOutOfStock && ` (${outOfStockCount} ຫມົດສະຕັອກ)`}
          </span>
        </Button>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6"
          onClick={() => setDismissed(true)}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>

      {isOpen && (
        <StockAlertList
          alerts={alerts}
          open={isOpen}
          onOpenChange={setIsOpen}
          onAcknowledge={onAcknowledge}
        />
      )}
    </>
  );
}
